import type {
    KnowledgeBasePayload,
    KnowledgeBaseResponse,
} from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/types";
import type { IFetchService } from "app/services/fetchService";
import type { GetRequestOptions } from "app/services/fetchService";

const DEFAULT_URL = "/sales-api/ai-agent/customization";

export default function createKnowledgeBaseApiService(apiClient: IFetchService) {
    return {
        getCustomization: (options?: Readonly<GetRequestOptions>): Promise<KnowledgeBaseResponse> => {
            return apiClient.get(DEFAULT_URL, undefined, options);
        },
        updateCustomization: (
            params: KnowledgeBasePayload,
            options?: Readonly<GetRequestOptions>,
        ): Promise<Response> => {
            return apiClient.put(DEFAULT_URL, params, options);
        },
        deleteFile: (fileId: string, options?: Readonly<GetRequestOptions>): Promise<void> => {
            return apiClient.delete(`${DEFAULT_URL}/files/${fileId}`, undefined, options);
        },
        uploadFile: (body: FormData): Promise<Response> => {
            return fetch(`${DEFAULT_URL}/files`, {
                method: "POST",
                body,
                credentials: "include",
            });
        },
        getFileProductOfferings: (fileId: string, options?: Readonly<GetRequestOptions>): Promise<string[]> => {
            return apiClient.get(`${DEFAULT_URL}/files/${fileId}/product-offerings`, undefined, options);
        },
        updateProductAndOfferings: (productAndOfferings: string[]): Promise<Response> => {
            return apiClient.put(`${DEFAULT_URL}/product-offerings`, { productAndOfferings });
        },
    };
}
